import type { Oekt } from "../state/session";
import { Tekstbord } from "../components/Tekstbord";
import { FELTER } from "../state/tekstflater";

/**
 * Beskjeder: tre felt, tre mottakere.
 *
 * Teknisk crew, innhold og prod. Det er ikke tre kopier av det samme — en
 * beskjed om batterier har ingenting i innholdssidens felt å gjøre, og den
 * som leser skal kunne hoppe rett til sitt.
 *
 * Ingen overskrift over feltene. Fanen heter «Brief», kortene heter hvem de
 * gjelder, og feltene er tomme felt man skriver i — det er ikke noe her en
 * setning kunne forklart bedre.
 */
export function BriefScreen(
  { oekt, felt }: {
    readonly oekt: Oekt;
    /* Feltene omraadet viser. Tom liste betyr alle — se state/omraade.ts. */
    readonly felt: readonly string[];
  },
): JSX.Element {
  /*
   * ========  PRODBRIEFEN STAAR HOS ALLE  ========
   *
   * Brukeren 02.11.2026: «Prod briefen skal vises hos alle, siden det er
   * den generelle briefen for dagen. Dette er ofte det de skriver i
   * mailen naar de sender dagsplan.»
   *
   * Omraadene filtrerer brieffeltene — «Teknisk» viser bare det tekniske
   * — og da forsvant nettopp den ene beskjeden som gjelder hele crewet:
   * «Elise, husk aa ta med lunsj til LET1 og deltakere.» Den staar naa
   * uansett hvilket omraade man har paa.
   */
  const valgte = felt.length === 0
    ? FELTER : FELTER.filter((f) => felt.includes(f.slug) || f.slug === "brief-prod");
  const vises = valgte;

  /*
   * ========  TRE FELT, TRE TILLATELSER  ========
   *
   * Redaktoer skriver innhold, A-foto eller A-lyd skriver teknisk,
   * koordinator og prodleder skriver prod. Produsenten skriver alle.
   * Resten LESER — rolle styrer skriving, ikke lesing.
   *
   * Regnet her OG i basen. `tilgang.skriver_tekstflate` er fasiten og
   * nekter uansett; dette er for at feltet ikke skal se skrivbart ut naar
   * det ikke er det. Se migrasjon 20261102150000.
   */
  const mine = [oekt.member.role, ...(oekt.member.extraRoles ?? [])];
  const har = (r: string): boolean => mine.includes(r as typeof mine[number]);
  const erAFoto = (oekt.member.craftNavn ?? "") === "A-foto"
    || (oekt.member.craftNavn ?? "") === "A-lyd";
  const skrivbar = (f: { readonly slug: string }): boolean => {
    if (har("produsent")) return true;
    if (f.slug === "brief-prod") return har("prodleder") || har("koordinator");
    if (f.slug === "brief-innhold") return har("redaktor");
    if (f.slug === "brief-teknisk") return har("afoto") || erAFoto;
    return true;
  };

  return (
    <div className="flate">
      <div className="flate__innhold">
        <Tekstbord
          produksjonId={oekt.production.id}
          felter={vises}
          plassholder={(f) => `Beskjed til ${f.tittel.toLowerCase()}`}
          skrivbar={skrivbar}
        />
      </div>
    </div>
  );
}
